import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-common-card-details-form',
  templateUrl: './common-card-details-form.component.html',
  styleUrls: ['./common-card-details-form.component.scss']
})
export class CommonCardDetailsFormComponent implements OnInit {

  @Input() commonForm!: FormGroup;
  @Input() showTransactionNumber = false;
  @Output() getCardTypeHandler = new EventEmitter<string>();
  isFocused: boolean = false;
  cardType!: string;

  constructor(
    public apiService: ApiService
  ) { }

  ngOnInit(): void {
  };

  detectCardType(cardNumber: string) {
    this.cardType = this.getCardType(cardNumber);
    this.getCardTypeHandler.emit(this.cardType);
  }
  getCardType(cardNumber: string): string {
    const cardNumberDigitsOnly = cardNumber.replace(/\D/g, '');
    const firstDigit = cardNumberDigitsOnly.charAt(0);
    if (firstDigit === '4') {
      return 'Visa';
    } else if (firstDigit === '5') {
      return 'Mastercard';
    } else if (firstDigit === '3') {
      return 'American Express';
    } else if (firstDigit === '6') {
      return 'Discover';
    } else {
      return 'Unknown';
    }
  }

}
